const theme = {
    title: 'light',
    color: {
        brand: {
            primary: {
                nth1: '#8601C9',
                nth2: '#6C01A3',
                nth3: '#B88BCF'
            },
            secondary: {
                nth1: '#307185',
                nth2: '#073F50',
                nth3: '#ADDABE',
                nth4: '#DBF4E5'
            },
            tertiary: {
                nth1: '#540074',
                nth2: '#400058',
                nth3: '#A07CAE',
                nth4: '#DED4E1'
            }
        },
        base: {
            nth1: '#39383A',
            nth2: '#808080',
            nth3: '#AFB5BA',
            nth4: '#F4F4F4'
        },
        alert: {
            error: {
                nth1: '#FC3E3E',
                nth2: '#CC0000',
                nth3: '#FF6565',
                nth4: '#FFEBEB'
            },
            success: {
                nth1: '#28B446',
                nth2: '#25A35A',
                nth3: '#BCEFD2',
                nth4: '#EEFBF4'
            },
            info: {
                nth1: '#04D7FB',
                nth2: '#03AFCC',
                nth3: '#AFF2FE',
                nth4: '#EBFCFF'
            },
            warning: {
                nth1: '#FF9900',
                nth2: '#E08100',
                nth3: '#FFDEAD',
                nth4: '#FFF7EB'
            }
        },
        neutral: {
            nth1: '#000000',
            nth2: '#5C5C5C',
            nth3: '#ADADAD',
            nth4: '#FFFFFF'
        },
        other: {
            like: '#EB4132',
            typea: '#FFFFFF'
        },
        modal: {
            nth1: 'rgba(0, 0, 0, 0.6);'
        }
    },
    font: {
        family: {
            brand: 'Source Sans Pro'
        },
        size: {
            xxs: '12px',
            xs: '14px',
            sm: '16px',
            md: '24px',
            lg: '32px',
            xl: '40px',
            xxl: '48px',
            bg: '64px'
        },
        weight: {
            bold: 700,
            semiBold: 600,
            regular: 400
        }
    },
    spacing: {
        stack: {
            nano: '4px',
            small: '8px',
            xxxs: '16px',
            xxs: '24px',
            xs: '32px',
            sm: '40px',
            md: '48px',
            lg: '56px',
            xl: '64px',
            xxl: '80px',
            xxxl: '120px',
            bg: '160px',
            giant: '200px'
        },
        inline: {
            nano: '4px',
            small: '8px',
            xxxs: '16px',
            xxs: '24px',
            xs: '32px',
            sm: '40px',
            md: '48px',
            lg: '64px',
            xl: '80px'
        }
    },
    border: {
        width: {
            none: '0px',
            line: '1px',
            thin: '2px',
            medium: '4px',
            strong: '8px'
        },
        radius: {
            none: '0px',
            tiny: '2px',
            light: '4px',
            medium: '8px',
            large: '16px',
            big: '24px',
            circle: '100%'
        }
    },
    shadow: {
        level1: '0px 2px 4px',
        level2: '0px 4px 8px',
        level3: '0px 8px 16px',
        level4: '0px 8px 24px 0px',
        level5: '0px 16px 32px'
    },
    opacity: {
        semiOpaque: '0.08',
        opaque: '0.64',
        medium: '0.32',
        semiTransparent: '0.16',
        transparent: '0.8'
    }
};
export { theme };
//# sourceMappingURL=theme.js.map